import { Layout, Table, Input, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import Header from "@components/Header";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { KEY_DEVICE_MANAGEMENT_CUSTOMERS_ADD } from "@static/PERMISSION_KEY";
import { FILTER_SIZE, MENU_SIZE, MODAL_SIZE, PAGE_SIZE } from "@static/SIZE";
import { getCustomerTableColumns } from "@static/TABLE/BASE_CUSTOMER_TABLE_COLUMNS";
import { getAuthUserPermissions } from "@utils/getAuthUserPermissions";
import { fetchAPI } from "@utils/https/fetchAPI";
import { useShowConfirmation } from "@utils/useShowConfirmation";

import { FormCreate } from "./FormCreate";
import { FormEdit } from "./FormEdit";

const SectionCreate = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
`;

export default () => {
  const showConfirmation = useShowConfirmation();
  const permission = getAuthUserPermissions();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [filterText, setFilterText] = useState("");
  const [dataList, setDataList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState({
    isOpen: false,
    modalType: null,
  });

  const [selectedData, setSelectedData] = useState(null);

  const onHandleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const onHandleFilterChange = (e) => {
    const value = _.get(e, ["target", "value"]);
    setFilterText(value);
  };

  const onHandleCreate = ({ modalType }) => {
    setIsModalVisible({ isOpen: true, modalType });
  };

  const onHandleEdit = ({ item }) => {
    setSelectedData(item);
    setIsModalVisible({ isOpen: true, modalType: "edit" });
  };

  const onHandleDelete = async ({ item }) => {
    const id = _.get(item, ["id"]);
    const resp = await fetchAPI({
      method: "delete",
      path: `/api/v1/customer/${id}`,
      isAuth: true,
    });
    if (_.get(resp, ["status"])) {
      toast.success("Delete Customer Success.");
      const updateDataList = _.chain(dataList)
        .filter((item) => {
          return _.get(item, ["id"]) !== id;
        })
        .map((item, index) => {
          return { ...item, index: index + 1 };
        })
        .value();
      setDataList(updateDataList);
    }
  };

  const filteredDataSource = _.filter(dataList, (item) => {
    const itemName = _.chain(item).get(["customer_name"]).toLower().value();
    const lowerFilterText = _.toLower(filterText);
    return _.includes(itemName, lowerFilterText);
  });

  const initData = async () => {
    const resp = await fetchAPI({
      method: "get",
      path: "/api/v1/customers",
      isAuth: true,
    });

    if (_.get(resp, ["status"])) {
      console.log("resp :>> ", resp);
      const results = _.chain(resp)
        .get(["result"])
        .map((item, index) => {
          return { key: index, index: index + 1, ...item };
        })
        .value();
      setDataList(results);
    }
  };

  useEffect(() => {
    initData();
  }, []);

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents>
            <SectionMainAction>
              <Input
                placeholder="Filter by name"
                value={filterText}
                onChange={(e) => onHandleFilterChange(e)}
                style={{ width: FILTER_SIZE }}
              />
              <SectionCreate>
                {_.includes(
                  permission,
                  KEY_DEVICE_MANAGEMENT_CUSTOMERS_ADD
                ) && (
                  <Button
                    onClick={() => onHandleCreate({ modalType: "create" })}
                    color={COLOR_GREEN}
                    fontColor={COLOR_WHITE}
                    padding="7px 15px"
                  >
                    Add Customer
                  </Button>
                )}
              </SectionCreate>
            </SectionMainAction>

            <Table
              dataSource={filteredDataSource}
              columns={getCustomerTableColumns({
                permission,
                onHandleEdit,
                onHandleDelete,
                showConfirmation,
              })}
              pagination={{
                position: ["bottomRight"],
                current: currentPage,
                pageSize: pageSize,
                showSizeChanger: true,
              }}
              // scroll={{
              //   x: 1000,
              // }}
              onChange={onHandleTableChange}
            />
          </InnerContents>
        </Content>
      </Layout>
      <Modal
        width={MODAL_SIZE}
        destroyOnClose={true}
        title={`${_.chain(isModalVisible)
          .get(["modalType"])
          .capitalize()
          .value()} Customer`}
        open={_.get(isModalVisible, ["isOpen"])}
        footer={null}
        onCancel={() =>
          setIsModalVisible((prev) => ({ ...prev, isOpen: false }))
        }
      >
        {_.get(isModalVisible, ["modalType"]) === "create" && (
          <FormCreate
            setIsModalVisible={setIsModalVisible}
            setDataList={setDataList}
            dataList={dataList}
          />
        )}
        {_.get(isModalVisible, ["modalType"]) === "edit" && (
          <FormEdit
            selectedData={selectedData}
            setIsModalVisible={setIsModalVisible}
            setDataList={setDataList}
            setSelectedData={setSelectedData}
          />
        )}
      </Modal>
    </Layout>
  );
};
